"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var CleanJson_1 = __importDefault(require("CleanJson/CleanJson"));
var BlockConflictResolver_1 = require("./BlockConflictResolver");
var OperationsChannel_1 = require("Common/OperationsChannel/OperationsChannel");
var HTTP_MESSAGES_1 = require("@CommonFrontendBackend/Utils/HTTP_MESSAGES");
var BlockPersister = (function () {
    function BlockPersister($rootScope, $log, options, persistenceTracker, block, project, di, collaboration, projectStore) {
        var _this = this;
        var externalBlockUpdate = function (version, blockData) {
            var e_1, _a;
            var blockId = blockData._id;
            var blockIndex = lodash_1.default.findIndex(project.blocks, { _id: blockId });
            if (blockIndex >= 0) {
                var mergedData = lodash_1.default.merge(project.blocks[blockIndex], blockData, { $skipPersistenceCycle: true });
                try {
                    for (var _b = __values(Object.keys(blockData.contentAreas)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var areaName = _c.value;
                        var area = blockData.contentAreas[areaName];
                        if (area.tokens != null) {
                            mergedData.contentAreas[areaName].tokens.splice(area.tokens.length);
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return mergedData;
            }
        };
        var blockConflictResolver = (0, BlockConflictResolver_1.createConflictResolver)(externalBlockUpdate);
        this.opChannel = di.make(OperationsChannel_1.OperationsChannel, {
            endpoint: options.apiRoute,
            startingPersistVersion: block.persistVersion,
            conflictResolver: blockConflictResolver,
            onFinishedProcessing: function (newVersion, hasRetried) {
                if (hasRetried) {
                    persistenceTracker.saveDone(_this, HTTP_MESSAGES_1.SUCCESS_NETWORK_RECONNECTED);
                }
                else {
                    persistenceTracker.saveDone(_this);
                }
                if (typeof onPersisted === "function") {
                    onPersisted();
                }
                return (_this.persistVersion = newVersion);
            },
            onRetry: function (errorMsg) {
                return persistenceTracker.warning(_this, errorMsg);
            },
            onError: function (errorMsg) {
                persistenceTracker.saveErrored(_this, errorMsg);
                return persistenceTracker.saveDone(_this);
            },
            processMode: OperationsChannel_1.QueueProcessMode.FastForward,
        });
        this.persistVersion = block.persistVersion;
        this.lastSent = (0, CleanJson_1.default)(block);
        this.changes = [];
        var objectKey = options.watchObject;
        var scope = options.scope || $rootScope;
        var DEBOUNCE_DELAY = options.throttling || 500;
        var dataTransformer = options.dataTransformer || (function (a) { return a; });
        var validation = options.validation || (function () { return true; });
        var onPersisted = options.onPersisted;
        var _updater = function (stringifiedWatchObject, oldVal) {
            if (shouldUpdate(stringifiedWatchObject, oldVal)) {
                var watchObject = convertToJson(stringifiedWatchObject);
                if (watchObject == null) {
                    return;
                }
                watchObject = dataTransformer(watchObject);
                var cleanedWatchObject = (0, CleanJson_1.default)(watchObject);
                return sendUpdate(cleanedWatchObject);
            }
        };
        var shouldUpdate = function (stringifiedWatchObject, oldVal) {
            if (!projectStore.isEditable) {
                return false;
            }
            if (stringifiedWatchObject === oldVal) {
                return false;
            }
            var originalObject = scope.$eval(objectKey);
            if (originalObject == null) {
                return false;
            }
            else if (originalObject.$skipPersistenceCycle) {
                delete originalObject.$skipPersistenceCycle;
                return false;
            }
            else if (originalObject.$collabCreated) {
                delete originalObject.$collabCreated;
                return false;
            }
            else if (collaboration.isBlockLocked(originalObject)) {
                return false;
            }
            else {
                return true;
            }
        };
        var convertToJson = function (stringifiedWatchObject) {
            var watchObject;
            try {
                watchObject = JSON.parse(stringifiedWatchObject);
            }
            catch (e) {
                $log.error(new Error("Got an error parsing a block for updating"));
                $log.error(e);
                return null;
            }
            if (watchObject == null) {
                return null;
            }
            if (!validation(watchObject)) {
                return null;
            }
            return watchObject;
        };
        var sendUpdate = function (sendData) {
            persistenceTracker.saveStarted(_this);
            _this.opChannel.sendOperation({
                payload: sendData,
            });
            _this.lastSent = sendData;
            return sendData;
        };
        var updater = lodash_1.default.debounce(_updater, DEBOUNCE_DELAY, {
            trailing: true,
            leading: false,
            maxWait: 1000,
        });
        scope.$watch(function () {
            var watchObject = scope.$eval(objectKey);
            var cleaned = (0, CleanJson_1.default)(watchObject);
            delete cleaned.lock;
            return JSON.stringify(cleaned);
        }, updater, true);
        scope.$on("$destroy", function () {
            return persistenceTracker.persistDestroyed(_this);
        });
    }
    return BlockPersister;
}());
exports.default = BlockPersister;
